import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './utils/context/AuthContext';
import LayoutRenderer from './utils/renderers/LayoutRenderer';
import LoginPage from './pages/user/Login';
import ForgotPasswordPage from './pages/user/ForgotPassword';
import ResetPasswordPage from './pages/user/ResetPassword';
import NotFoundPage from './pages/errors/NotFound';
import ForbiddenPage from './pages/errors/Forbidden';
import BadRequestPage from './pages/errors/BadRequest';
import UnauthorizedPage from './pages/errors/Unauthorized';
import ServerErrorPage from './pages/errors/ServerError';
import { protectedRoutes } from './utils/routes/routesConfig';
import { ProtectedRoute } from './utils/routes/ProtectedRoute';
import MyAccountPage from './pages/MyAccount';
import { PrivateRoute } from './utils/routes/PrivateRoute';
import FaqPage from './pages/extra/FAQ';
import BrowserCheck from './utils/tools/BrowserCheck';
import { ErrorBoundary } from './utils/tools/ErrorBoundary';

function App() {
    return (
        <React.StrictMode>
            <Router>
                <BrowserCheck>
                    <AuthProvider>
                        <ErrorBoundary>
                            <Routes>
                                <Route path="/login" element={<LayoutRenderer Component={LoginPage} />} />
                                <Route path="/forgot-password" element={<LayoutRenderer Component={ForgotPasswordPage} />} />
                                <Route path="/reset-password" element={<LayoutRenderer Component={ResetPasswordPage} />} />

                                {protectedRoutes.map((route) => (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        element={
                                            <ProtectedRoute resource={route.resource} requiredPermission={route.requiredPermission}>
                                                <LayoutRenderer Component={route.component} />
                                            </ProtectedRoute>
                                        }
                                    >
                                        {route.subRoutes?.map((sr) => (
                                            <Route
                                                key={sr.path}
                                                path={sr.path}
                                                element={
                                                    <ProtectedRoute resource={route.resource} requiredPermission={sr.requiredPermission}>
                                                        <LayoutRenderer Component={sr.subComponent ?? route.component} />
                                                    </ProtectedRoute>
                                                }
                                            />
                                        ))}
                                    </Route>
                                ))}

                                <Route
                                    path="/profil"
                                    element={
                                        <PrivateRoute>
                                            <LayoutRenderer Component={MyAccountPage} />
                                        </PrivateRoute>
                                    }
                                />

                                <Route
                                    path="/faq"
                                    element={
                                        <PrivateRoute>
                                            <LayoutRenderer Component={FaqPage} />
                                        </PrivateRoute>
                                    }
                                />

                                <Route path="/bad-request" element={<BadRequestPage />} />
                                <Route path="/unauthorized" element={<UnauthorizedPage />} />
                                <Route path="/forbidden" element={<ForbiddenPage />} />
                                <Route path="/server-error" element={<ServerErrorPage />} />

                                <Route path="*" element={<NotFoundPage />} />
                            </Routes>
                        </ErrorBoundary>
                    </AuthProvider>
                </BrowserCheck>
            </Router>
        </React.StrictMode>
    );
}

export default App;
